export enum StatusSprawy {
  Nowa = 1,
  Przydzielono = 2,
  WTrakcieWeryfikacji = 3,
  OczekujeNaRozpatrzenie = 4,
  WTrakcieRozpatrywania = 5,
  OczekujeNaWydanieDecyzji = 6,
  WydanoDecyzje = 7,
  DoreczonoDecyzje = 8,
  UprawomocnionoDecyzje = 9,
  WygenerowanoSzablonPostanowienia = 10,
  OczekujeNaPodpisPostanowienia = 11,
  WydanoPostanowienie = 12,
  OczekujeNaPotwierdzenieOtrzymaniaPostanowienia = 13,
  DoreczonoPostanowienie = 14,
  DoUmorzenia = 15,
  OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania = 16,
  WydanoDecyzjeOUmorzeniuPostepowania = 17,
  OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania = 18,
  DoreczonoDecyzjeOUmorzeniuPostepowania = 19,
  UprawomocnionoDecyzjeOUmorzeniuPostepowania = 20,
  PrzydzielonoDoSprawyZUrzeduPracownika = 21,
  ZawiadomienieOWszczeciu = 22,
  WTrakcieWeryfikacjiPoZawiadomieniu = 23,
  WszczetoPostepownieStwierdzonoBrakiFormalne = 24,
  SprawaZamknietaWycofanoPodnie = 25,
  WplyneloOdwolanie = 26,
  WPrzygotowaniuDoDrugiejInstancji = 27,
  PrzekazanoDoDrugiejInstancji = 28,
  RozpatrywanieOdwolania = 29,
  OczekujeNaWydanieDecyzjiOdwolanie = 30,
  WydanoDecyzjeOdwolanie = 31,
  DecyzjaDoreczonaOdwolanie = 32,
  DecyzjaPrawomocnaOdwolanie = 33,
  WPrzygotowaniuDecyzjiZmieniajacej = 34,
  OczekujeNaWydanieDecyzjiZmieniajacej = 35,
  WydanoDecyzjeZmieniajaca = 36,
  DoreczonoDecyzjeZmieniajaca = 37,
  UprawomocnionoDecyzjeZmieniajaca = 38,
  Zarchiwizowano = 39,
  WplynalWniosekOPonowneRozpatrzenie = 40,
  DecyzjaOPonowneRozpatrzenieWPrzygotowaniu = 41,
  OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie = 42,
  WydanoDecyzjeOPonowneRozpatrzenie = 43,
  DecyzjaOPonowneRozpatrzenieDoreczona = 44,
  DecyzjaOPonowneRozpatrzeniePrawomocna = 45,
  WygenerowanoSzablonDecyzjiZmieniajacej = 46,
  SprawaZostawionaBezRozpoznania = 47,
}
